(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["3do-v6-customize-trigger"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do-product-customize')) {
    class DoProductCustomize extends HTMLElement {
      connectedCallback() {
        if (this.closest('dialog, product-card, .quick-add-modal')) return;
        this.abort = new AbortController();
        this.boundForms = new WeakSet();
        const { signal } = this.abort;
        if (!this.initialized) this.initialize();
        this.addEventListener('toggle', () => {
          this.refreshControls();
          this.syncTrigger();
          if (this.details.open) this.preparePreview();
        }, { signal, capture: true });
        this.addEventListener('click', (event) => {
          this.refreshControls();
          if (event.target.closest('[data-customize-open]') && this.variantPending) {
            event.preventDefault();
          } else if (event.target.closest('[data-customize-reset]')) {
            event.preventDefault();
            this.reset();
          }
        }, { signal });
        document.addEventListener('quantity-selector:update', () => this.syncTrigger(), { signal });
        document.addEventListener('input', (event) => {
          if (this.form?.contains(event.target) && event.target.name === 'quantity') this.syncTrigger();
        }, { signal });
        this.addEventListener('input', (event) => {
          this.refreshControls();
          if (event.target === this.note) {
            this.changed();
            return;
          }
          if (event.target.matches('[data-customize-tone]')) this.changed();
        }, { signal });
        document.addEventListener('variant:selected', (event) => {
          if (event.target.closest('product-form-component, .shopify-section')?.contains(this.form)) {
            this.variantPending = true;
            this.syncAvailability();
          }
        }, { signal });
        document.addEventListener('variant:update', () => {
          this.variantPending = false;
          this.syncAvailability();
        }, { signal });
        document.addEventListener('submit', (event) => {
          if (event.target !== this.form) return;
          this.refreshControls();
          if (this.hasCustomization() && !this.dataset.feeVariant) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.details.open = true;
            this.status.textContent = this.text.fee_unavailable;
            this.status.scrollIntoView({ block: 'nearest' });
            return;
          }
          if (!this.valid() && this.isPhysical()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.details.open = true;
            this.status.textContent = this.text.invalid;
            this.groups.find((group) => !this.choice(group))?.radios[0]?.focus();
            return;
          }
          this.syncProperties();
        }, { signal, capture: true });
        window.addEventListener('pageshow', () => this.syncAvailability(), { signal });
        this.syncAvailability();
      }

      disconnectedCallback() {
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
        this.removeProperties();
      }

      initialize() {
        this.initialized = true;
        this.details = this.querySelector('details');
        this.note = this.querySelector('[data-customize-note]');
        this.status = this.querySelector('[data-customize-status]');
        this.caption = this.querySelector('[data-preview-caption]');
        this.original = this.querySelector('.do-customize__original');
        this.canvas = this.querySelector('[data-preview-canvas]');
        this.text = Object.fromEntries(Array.from(this.querySelector('[data-customize-texts]').content.querySelectorAll('[data-key]'), (element) => [element.dataset.key, element.textContent]));
        this.variants = JSON.parse(this.querySelector('[data-customize-variants]').textContent);
        this.paletteVersion = 'petg-2026-09-v1';
        this.palette = [
          ['P04', '#FFFFFF', 'shade_white'], ['P05', '#F4F9FF', 'shade_white'],
          ['P06', '#EEE7D4', 'shade_cream'], ['P07', '#F0E0D6', 'shade_beige'],
          ['P19', '#C2B29A', 'shade_beige'], ['P08', '#75787B', 'shade_grey'],
          ['P01', '#000000', 'shade_black'], ['P02', '#1D0E07', 'shade_brown'],
          ['P20', '#362111', 'shade_brown'], ['P03', '#28334A', 'shade_navy'],
          ['P12', '#1729AB', 'shade_blue'], ['P13', '#00A3E0', 'shade_cyan'],
          ['P17', '#1DAA27', 'shade_green'], ['P18', '#5A6D3D', 'shade_olive'],
          ['P14', '#FFF13F', 'shade_yellow'], ['P15', '#EAC642', 'shade_yellow'],
          ['P16', '#ED7334', 'shade_orange'], ['P09', '#BC2726', 'shade_red'],
          ['P10', '#C52E79', 'shade_pink'], ['P11', '#685BC7', 'shade_purple']
        ].map(([id, hex, shade]) => ({ id, hex, shade }));
        const originalColours = {
          terrakotta: '#BF5931', rot: '#8F2528', creme: '#D8C8AC', weiß: '#EEEEEB', weiss: '#EEEEEB',
          graublau: '#7D929E', dunkelgrau: '#484B4F', dunkelblau: '#263B56', kupfer: '#B7774C', marineblau: '#1C2A44',
          elfenbein: '#E4DDC8', schwarz: '#272727', goldfarben: '#C0A257', gold: '#C0A257', taupe: '#9A8D80',
          salbeigrün: '#94A48C', violett: '#795495', petrol: '#28656C', anthrazit: '#41464A', silber: '#B8BBBF',
          himmelblau: '#91C5DD', silbergrau: '#B0B4B8', grün: '#557C54', blau: '#326EA7', gelb: '#E6C747', orange: '#D77C36',
          white: '#EEEEEB', red: '#8F2528', cream: '#D8C8AC', black: '#272727', blue: '#326EA7', green: '#557C54',
          terracotta: '#BF5931', ivory: '#E4DDC8', copper: '#B7774C', silver: '#B8BBBF', anthracite: '#41464A',
          'grey blue': '#7D929E', 'dark grey': '#484B4F', 'dark blue': '#263B56', 'navy blue': '#1C2A44',
          'sage green': '#94A48C', 'sky blue': '#91C5DD'
        };
        const description = new DOMParser().parseFromString(this.dataset.description || '', 'text/html');
        const heading = Array.from(description.querySelectorAll('h2, h3')).find((element) => /^(farbwelt|farbpalette|farben|colou?r palette|colou?rs)$/i.test(element.textContent.trim()));
        let names = heading?.nextElementSibling?.matches('ul, ol') ? Array.from(heading.nextElementSibling.querySelectorAll('li'), (element) => element.textContent.trim()) : [];
        if (!names.length) names = JSON.parse(this.dataset.tags || '[]').filter((name) => originalColours[name.toLocaleLowerCase()]);
        names = Array.from(new Set(names)).filter(Boolean).slice(0, 8);
        this.groups = names.map((name, index) => {
          const hex = originalColours[name.toLocaleLowerCase()] || null;
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'do-customize__group';
          const legend = document.createElement('legend');
          legend.textContent = `${this.text.group} ${index + 1}`;
          const source = document.createElement('p');
          source.className = 'do-customize__source';
          source.textContent = `${this.text.original}: ${name}`;
          const grid = document.createElement('div');
          grid.className = 'do-customize__swatches';
          const radios = [];
          const swatch = (id, color, label, original = false) => {
            const wrapper = document.createElement('label');
            wrapper.className = `do-customize__swatch${original ? ' do-customize__swatch-original' : ''}`;
            const radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = `do-customize-${this.dataset.instanceId}-${index}`;
            radio.value = id;
            radio.checked = original;
            radio.defaultChecked = original;
            radio.dataset.customizeTone = 'true';
            radio.setAttribute('aria-label', label);
            const chip = document.createElement('span');
            chip.className = 'do-customize__chip';
            chip.setAttribute('aria-hidden', 'true');
            if (color) chip.style.setProperty('--customize-swatch', color);
            wrapper.append(radio, chip);
            if (original) wrapper.append(document.createTextNode(label));
            radios.push(radio);
            return wrapper;
          };
          const originalOption = swatch('original', hex, this.text.original_single, true);
          this.palette.forEach((option) => grid.append(swatch(option.id, option.hex, `${this.text.tone} ${option.id}: ${this.text[option.shade]}`)));
          fieldset.append(legend, source, originalOption, grid);
          this.querySelector('[data-color-groups]').append(fieldset);
          return { name, hex, fieldset, radios };
        });
        if (this.dataset.previewProfile !== 'terrakotta-v1') this.caption.textContent = this.text.preview_missing;
        this.status.textContent = this.text.standard;
      }

      findForm() {
        const component = this.closest('product-form-component');
        this.form = component?.querySelector('form') || null;
        if (this.form && !this.boundForms.has(this.form)) {
          this.boundForms.add(this.form);
          this.form.addEventListener('formdata', (event) => {
            this.refreshControls();
            this.groups.forEach((group) => group.radios.forEach((radio) => event.formData.delete(radio.name)));
            ['_3dorder_customize', '_3dorder_customize_fee_variant', this.text.property_colors, this.text.property_note].forEach((key) => event.formData.delete(`properties[${key}]`));
            Object.entries(this.propertyValues()).forEach(([key, value]) => event.formData.set(`properties[${key}]`, value));
          }, { signal: this.abort.signal });
        }
        return this.form;
      }

      refreshControls() {
        this.details = this.querySelector('details');
        this.note = this.querySelector('[data-customize-note]');
        this.status = this.querySelector('[data-customize-status]');
        this.caption = this.querySelector('[data-preview-caption]');
        this.original = this.querySelector('.do-customize__original');
        const rows = this.querySelectorAll('.do-customize__group');
        this.groups.forEach((group, index) => {
          if (!rows[index]) return;
          group.fieldset = rows[index];
          group.radios = Array.from(rows[index].querySelectorAll('[data-customize-tone]'));
        });
        const canvas = this.querySelector('[data-preview-canvas]');
        if (canvas !== this.canvas && this.source) {
          canvas.width = this.source.width;
          canvas.height = this.source.height;
          this.context = canvas.getContext('2d', { willReadFrequently: true });
        }
        this.canvas = canvas;
      }

      currentVariant() {
        const id = this.form?.querySelector('input[name="id"]')?.value || this.dataset.initialVariant;
        return this.variants.find((variant) => String(variant.id) === id);
      }

      isPhysical() { return this.currentVariant()?.physical === true; }
      hasCustomization() { return this.isPhysical() && !!(this.selections().length || this.note.value.trim()); }
      valid() { return this.groups.every((group) => !!this.choice(group)); }

      choice(group) {
        const id = group.radios.find((radio) => radio.checked)?.value;
        return id === 'original' ? { id, hex: group.hex } : this.palette.find((option) => option.id === id);
      }

      selections() {
        return this.groups.flatMap((group) => {
          const option = this.choice(group);
          return option && option.id !== 'original' ? [{ source: group.name, color: option.hex, tone: option.id }] : [];
        });
      }

      removeProperties() {
        this.form?.querySelectorAll('[data-do-customize-property]').forEach((input) => input.remove());
        if (this.form) delete this.form.dataset.doCustomizeFeeVariant;
      }

      syncProperties() {
        this.findForm();
        this.removeProperties();
        if (!this.form) return;
        if (this.hasCustomization() && this.dataset.feeVariant) this.form.dataset.doCustomizeFeeVariant = this.dataset.feeVariant;
        Object.entries(this.propertyValues()).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = value;
          input.dataset.doCustomizeProperty = 'true';
          this.form.append(input);
        });
      }

      propertyValues() {
        if (!this.isPhysical() || !this.valid()) return {};
        const selections = this.selections();
        const note = this.note.value.trim();
        if (!selections.length && !note) return {};
        const values = { _3dorder_customize: JSON.stringify({ version: 3, palette: this.paletteVersion, product: this.dataset.productId, image: this.dataset.imageId, groups: selections, note, feeVariant: this.dataset.feeVariant, feePerUnit: Number(this.dataset.feePrice), currency: this.dataset.currency }), _3dorder_customize_fee_variant: this.dataset.feeVariant };
        if (selections.length) values[this.text.property_colors] = selections.map((selection) => `${selection.source} → ${selection.color}`).join(' / ');
        if (note) values[this.text.property_note] = note;
        return values;
      }

      syncAvailability() {
        this.refreshControls();
        this.findForm();
        const physical = this.isPhysical();
        this.groups.forEach((group) => {
          group.fieldset.disabled = !physical;
          group.radios.forEach((radio) => { radio.disabled = !physical; });
        });
        this.note.disabled = !physical;
        this.details.hidden = !physical;
        this.syncProperties();
        this.syncTrigger();
      }

      syncTrigger() {
        this.hidden = !this.form || !this.isPhysical();
        const trigger = this.querySelector('[data-customize-open]');
        trigger.setAttribute('aria-expanded', String(this.details.open));
        trigger.setAttribute('aria-disabled', String(!!this.variantPending));
        const summary = this.querySelector('[data-customize-price-summary]');
        if (!this.hasCustomization()) {
          summary.textContent = this.text.trigger_hint;
          return;
        }
        const quantity = Number(this.form.querySelector('[name="quantity"]')?.value) || 1;
        const unit = this.currentVariant().price + Number(this.dataset.feePrice);
        const money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        summary.textContent = this.text.price_summary.replace('[unit]', money.format(unit / 100)).replace('[total]', money.format(unit * quantity / 100));
      }

      changed() {
        this.syncAvailability();
        this.status.textContent = this.valid() ? (this.selections().length || this.note.value.trim() ? this.text.ready : this.text.standard) : this.text.invalid;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.renderPreview());
      }

      reset() {
        this.groups.forEach((group) => {
          group.radios.forEach((radio) => { radio.checked = radio.value === 'original'; });
        });
        this.note.value = '';
        this.changed();
      }

      async preparePreview() {
        if (!this.original || this.dataset.previewProfile !== 'terrakotta-v1' || this.previewLoading || this.source) return;
        this.previewLoading = true;
        try {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = this.original.currentSrc || this.original.src;
          await image.decode();
          if (!this.isConnected) return;
          const scale = Math.min(1, 720 / Math.max(image.naturalWidth, image.naturalHeight));
          this.canvas.width = Math.round(image.naturalWidth * scale);
          this.canvas.height = Math.round(image.naturalHeight * scale);
          this.context = this.canvas.getContext('2d', { willReadFrequently: true });
          this.context.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
          this.source = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
          this.prepareRegions();
          this.renderPreview();
        } catch {
          this.source = null;
          this.caption.textContent = this.text.preview_error;
        } finally {
          this.previewLoading = false;
        }
      }

      rgbToHsl(r, g, b) {
        r /= 255; g /= 255; b /= 255;
        const max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min;
        const l = (max + min) / 2;
        if (!delta) return [0, 0, l];
        const s = delta / (1 - Math.abs(2 * l - 1));
        let h = max === r ? ((g - b) / delta + (g < b ? 6 : 0)) : max === g ? ((b - r) / delta + 2) : ((r - g) / delta + 4);
        return [h / 6, s, l];
      }

      hslToRgb(h, s, l) {
        const c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h * 6) % 2 - 1)), m = l - c / 2;
        const rgb = h < 1 / 6 ? [c, x, 0] : h < 2 / 6 ? [x, c, 0] : h < 3 / 6 ? [0, c, x] : h < 4 / 6 ? [0, x, c] : h < 5 / 6 ? [x, 0, c] : [c, 0, x];
        return rgb.map((value) => Math.round((value + m) * 255));
      }

      prepareRegions() {
        const pixels = this.source.data, count = pixels.length / 4;
        this.regions = new Int8Array(count).fill(-1);
        this.weights = new Float32Array(count);
        this.light = new Float32Array(count);
        this.saturation = new Float32Array(count);
        const totals = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
        for (let i = 0; i < count; i++) {
          const p = i * 4, r = pixels[p], g = pixels[p + 1], b = pixels[p + 2];
          const chroma = Math.max(r, g, b) - Math.min(r, g, b);
          if (pixels[p + 3] < 16 || chroma < 8) continue;
          const [h, s, l] = this.rgbToHsl(r, g, b);
          let region = -1;
          if (h > .94 || h <= .021) region = 1;
          else if (h <= .072) region = 0;
          else if (h <= .18 && l > .23) region = 2;
          const x = (i % this.source.width) / this.source.width;
          const y = Math.floor(i / this.source.width) / this.source.height;
          if (region === 1 && x > .37 && x < .71 && y > .43 && y < .468) region = 0;
          if (region < 0 || s < .075) continue;
          const weight = Math.min(1, (chroma - 8) / 12);
          this.regions[i] = region;
          this.weights[i] = weight;
          this.light[i] = l;
          this.saturation[i] = s;
          totals[region][0] += l * weight;
          totals[region][1] += s * weight;
          totals[region][2] += weight;
        }
        this.centers = totals.map(([l, s, count]) => [l / (count || 1), s / (count || 1)]);
      }

      renderPreview() {
        if (!this.source || !this.valid()) return;
        const sourceNames = [['terrakotta', 'terracotta'], ['rot', 'red'], ['creme', 'cream']];
        const targets = sourceNames.map((names) => {
          const group = this.groups.find((entry) => names.includes(entry.name.toLocaleLowerCase()));
          const option = group && this.choice(group);
          if (!option || option.id === 'original') return null;
          const hex = option.hex;
          return this.rgbToHsl(parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16));
        });
        const changed = targets.some(Boolean);
        this.canvas.hidden = !changed;
        this.original.hidden = changed;
        this.caption.textContent = changed ? this.text.preview : this.text.original;
        if (!changed) return;
        const output = new ImageData(new Uint8ClampedArray(this.source.data), this.source.width, this.source.height);
        for (let i = 0; i < this.regions.length; i++) {
          const region = this.regions[i], target = targets[region];
          if (!target) continue;
          const [h, s, l] = target, [centerL, centerS] = this.centers[region];
          const light = this.light[i];
          const mappedL = light <= centerL ? l * light / Math.max(.01, centerL) : l + (1 - l) * (light - centerL) / Math.max(.01, 1 - centerL);
          const mappedS = Math.min(1, s * Math.pow(this.saturation[i] / Math.max(.01, centerS), .2));
          const rgb = this.hslToRgb(h, mappedS, Math.max(0, Math.min(1, mappedL)));
          const weight = this.weights[i], p = i * 4;
          for (let channel = 0; channel < 3; channel++) output.data[p + channel] = this.source.data[p + channel] * (1 - weight) + rgb[channel] * weight;
        }
        this.context.putImageData(output, 0, 0);
      }
    }
    customElements.define('do-product-customize', DoProductCustomize);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-cart-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-consent')) {
    class CartConsent extends HTMLElement {
      static observedAttributes = ['data-cart-signature'];

      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('change', () => this.sync(), options);
        this.addEventListener('submit', (event) => {
          if (!this.accepted()) {
            event.preventDefault();
            this.querySelector('input[required]:not(:checked)')?.focus();
            return;
          }
          const timestamp = this.querySelector('[data-consent-time]');
          if (timestamp) timestamp.value = new Date().toISOString();
        }, options);
        document.addEventListener('cart:update', () => this.reset(), options);
        document.addEventListener('quantity-selector:update', () => this.reset(), options);
        window.addEventListener('pageshow', () => this.reset(), options);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this, { childList: true, subtree: true });
        queueMicrotask(() => this.reset());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      attributeChangedCallback() {
        if (this.isConnected) queueMicrotask(() => this.reset());
      }

      accepted() {
        const checkboxes = [...this.querySelectorAll('input[required]')];
        return this.dataset.ready === 'true' && checkboxes.length > 0 && checkboxes.every((input) => input.checked);
      }

      reset() {
        this.querySelectorAll('input[required]').forEach((input) => { input.checked = false; });
        const timestamp = this.querySelector('[data-consent-time]');
        if (timestamp) timestamp.value = '';
        this.sync();
      }

      sync() {
        const accepted = this.accepted();
        const button = this.querySelector('button[name="checkout"]');
        if (button) button.disabled = !accepted;
        const status = this.querySelector('[data-consent-status]');
        const message = accepted ? this.dataset.readyMessage : this.dataset.waitingMessage;
        if (status && status.textContent !== message) status.textContent = message;
      }
    }
    customElements.define('cart-consent', CartConsent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-deal-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do-deal-countdown')) {
    customElements.define('do-deal-countdown', class extends HTMLElement {
      static get observedAttributes() { return ['data-deadline']; }
      connectedCallback() { this.start(); }
      disconnectedCallback() { clearInterval(this.timer); }
      attributeChangedCallback() { if (this.isConnected) this.start(); }
      start() {
        clearInterval(this.timer);
        // Only absolute ISO timestamps are valid; a date alone has no end time.
        const raw = this.dataset.deadline || '';
        this.end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
        if (this.update()) this.timer = setInterval(() => this.update(), 1000);
      }
      update() {
        const active = this.querySelector('[data-timer-active]');
        const expired = this.querySelector('[data-timer-expired]');
        const time = this.querySelector('time');
        if (!active || !expired || !time) return false;
        const seconds = Math.ceil((this.end - Date.now()) / 1000);
        const valid = Number.isFinite(seconds) && seconds > 0;
        active.hidden = !valid;
        expired.hidden = valid;
        if (!valid) {
          clearInterval(this.timer);
          time.textContent = '';
          time.removeAttribute('datetime');
          return false;
        }
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        const rest = seconds % 60;
        time.textContent = [hours, minutes, rest].map(value => String(value).padStart(2, '0')).join(':');
        time.dateTime = this.dataset.deadline;
        return true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do-delivery-estimate')) {
    customElements.define('do-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const variants = JSON.parse(this.querySelector('[data-delivery-variants]')?.textContent || '[]');
        document.addEventListener('variant:update', (event) => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const variant = variants.find((item) => String(item.id) === String(event.detail?.resource?.id));
          this.hidden = !variant?.physical;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('do-product-discovery')) {
    customElements.define('do-product-discovery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const filters = this.querySelector('.do-discovery__filters');
        if (!filters) return;
        filters.hidden = false;
        filters.addEventListener('click', (event) => {
          const button = event.target.closest('[data-discovery-filter]');
          if (!button) return;
          filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-discovery-group]').forEach((card) => {
            card.hidden = button.dataset.discoveryFilter !== 'all' && card.dataset.discoveryGroup !== button.dataset.discoveryFilter;
          });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-favorites-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const legacyStorageKey = '3dorder:favorites:v1';
    const guestStorageKey = '3dorder:favorites:v2:guest';
    const maxFavorites = 100;
    const dialog = document.querySelector('[data-favorites-dialog]');
    if (!dialog) return;

    const list = dialog.querySelector('[data-favorites-list]');
    const empty = dialog.querySelector('[data-favorites-empty]');
    const status = dialog.querySelector('[data-favorites-status]');
    const customerId = (dialog.dataset.customerId || '').trim();
    const isAuthenticated = dialog.dataset.customerAuthenticated === 'true' && customerId !== '';
    const storageKey = isAuthenticated
      ? '3dorder:favorites:v2:customer:' + customerId
      : guestStorageKey;
    const pendingStorageKey = isAuthenticated ? storageKey + ':pending' : '';
    const endpoint = dialog.dataset.favoritesEndpoint || '';
    let syncQueued = false;
    let syncTimer;
    let syncRequest;
    let changeVersion = 0;
    let syncAgain = false;

    const normalizeId = (value) => {
      const id = String(value || '').split('/').pop();
      return /^\d+$/.test(id) ? id : '';
    };

    const normalizeFavorite = (item) => {
      if (!item || typeof item !== 'object') return null;
      const id = normalizeId(item.id || item.productId);
      if (!id) return null;
      return {
        id,
        handle: String(item.handle || ''),
        url: String(item.url || ''),
        title: String(item.title || ''),
        image: String(item.image || ''),
        price: String(item.price || ''),
        variantId: normalizeId(item.variantId)
      };
    };

    const normalizeFavorites = (items) => {
      if (!Array.isArray(items)) return [];
      const unique = new Map();
      items.forEach((item) => {
        const normalized = normalizeFavorite(item);
        if (normalized && !unique.has(normalized.id)) unique.set(normalized.id, normalized);
      });
      return Array.from(unique.values()).slice(0, maxFavorites);
    };

    const mergeFavorites = (primary, secondary) => {
      const merged = new Map();
      normalizeFavorites(secondary).forEach((item) => merged.set(item.id, item));
      normalizeFavorites(primary).forEach((item) => {
        merged.set(item.id, { ...(merged.get(item.id) || {}), ...item });
      });
      return Array.from(merged.values()).slice(0, maxFavorites);
    };

    const readStored = (key) => {
      try {
        return normalizeFavorites(JSON.parse(localStorage.getItem(key) || '[]'));
      } catch {
        return [];
      }
    };

    const storeItems = (key, items) => {
      try {
        localStorage.setItem(key, JSON.stringify(normalizeFavorites(items)));
        return true;
      } catch {
        return false;
      }
    };

    const removeStored = (key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        return;
      }
    };

    const readPendingMode = () => {
      if (!pendingStorageKey) return '';
      try {
        return localStorage.getItem(pendingStorageKey) || '';
      } catch {
        return '';
      }
    };

    const setPendingMode = (mode) => {
      if (!pendingStorageKey) return;
      try {
        localStorage.setItem(pendingStorageKey, mode);
      } catch {
        return;
      }
    };

    const clearPendingMode = () => {
      if (pendingStorageKey) removeStored(pendingStorageKey);
    };

    const migrateLocalFavorites = () => {
      const legacyItems = readStored(legacyStorageKey);
      if (legacyItems.length) {
        const guestItems = mergeFavorites(readStored(guestStorageKey), legacyItems);
        if (storeItems(guestStorageKey, guestItems)) removeStored(legacyStorageKey);
      }

      if (!isAuthenticated) return;
      const guestItems = readStored(guestStorageKey);
      if (!guestItems.length) return;

      const accountItems = mergeFavorites(readStored(storageKey), guestItems);
      if (storeItems(storageKey, accountItems)) {
        removeStored(guestStorageKey);
        if (readPendingMode() !== 'replace') setPendingMode('merge');
      }
    };

    migrateLocalFavorites();

    const readFavorites = () => readStored(storageKey);

    const safeProductUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin ? url.pathname + url.search : '#';
      } catch {
        return '#';
      }
    };

    const safeImageUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch {
        return '';
      }
    };

    const updateButtons = (items) => {
      const ids = new Set(items.map((item) => String(item.id)));
      document.querySelectorAll('[data-favorite-button]').forEach((button) => {
        const active = ids.has(normalizeId(button.dataset.favoriteId));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.addLabel);
        const text = button.querySelector('[data-favorite-button-text]');
        if (text) text.textContent = active ? dialog.dataset.savedText : dialog.dataset.saveText;
      });
    };

    const updateCounts = (count) => {
      document.querySelectorAll('[data-favorites-count]').forEach((badge) => {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      });
    };

    const createFavoriteItem = (item) => {
      const article = document.createElement('article');
      article.className = 'do-favorite-item';

      const imageLink = document.createElement('a');
      imageLink.className = 'do-favorite-item__image';
      imageLink.href = safeProductUrl(item.url);
      const imageUrl = safeImageUrl(item.image);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = item.title || '';
        image.loading = 'lazy';
        image.width = 184;
        image.height = 184;
        imageLink.append(image);
      }

      const content = document.createElement('div');
      content.className = 'do-favorite-item__content';

      const title = document.createElement('a');
      title.className = 'do-favorite-item__title';
      title.href = safeProductUrl(item.url);
      title.textContent = item.title || '';

      const price = document.createElement('p');
      price.className = 'do-favorite-item__price';
      price.textContent = item.price || '';

      const actions = document.createElement('div');
      actions.className = 'do-favorite-item__actions';

      const view = document.createElement('a');
      view.className = 'do-favorite-item__view';
      view.href = safeProductUrl(item.url);
      view.textContent = dialog.dataset.viewText;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'do-favorite-item__remove';
      remove.dataset.favoriteRemove = item.id;
      remove.textContent = dialog.dataset.removeText;

      actions.append(view, remove);
      content.append(title, price, actions);
      article.append(imageLink, content);
      return article;
    };

    const renderFavorites = () => {
      const items = readFavorites();
      list.replaceChildren(...items.map(createFavoriteItem));
      empty.hidden = items.length > 0;
      updateCounts(items.length);
      updateButtons(items);
      window.dispatchEvent(new CustomEvent('3dorder:favorites:rendered', {
        detail: { count: items.length }
      }));
    };

    const syncPayload = (items) => ({
      favorites: normalizeFavorites(items).map((item) => ({
        productId: 'gid://shopify/Product/' + item.id,
        variantId: item.variantId ? 'gid://shopify/ProductVariant/' + item.variantId : null
      }))
    });

    const fetchFavorites = async (options = {}) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 7000);
      try {
        const response = await fetch(endpoint, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', ...(options.headers || {}) },
          signal: controller.signal,
          ...options
        });
        if (!response.ok) throw new Error('Favorites sync failed');
        return await response.json();
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const pushFavorites = async () => {
      if (!isAuthenticated || !endpoint) return;
      if (syncRequest) {
        syncAgain = true;
        return syncRequest;
      }

      const requestVersion = changeVersion;
      const items = readFavorites();
      syncRequest = fetchFavorites({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(syncPayload(items))
      });

      try {
        const payload = await syncRequest;
        if (requestVersion === changeVersion) {
          const savedItems = normalizeFavorites(payload && payload.favorites);
          if (savedItems.length || items.length === 0) storeItems(storageKey, savedItems);
          clearPendingMode();
          renderFavorites();
        } else {
          syncAgain = true;
        }
      } catch {
        setPendingMode(readPendingMode() || 'replace');
      } finally {
        syncRequest = null;
        if (syncAgain) {
          syncAgain = false;
          window.clearTimeout(syncTimer);
          syncTimer = window.setTimeout(pushFavorites, 250);
        }
      }
    };

    const queueSync = () => {
      if (!isAuthenticated || !endpoint) return;
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(pushFavorites, 450);
    };

    const writeFavorites = (items) => {
      if (!storeItems(storageKey, items)) return;
      if (isAuthenticated) {
        changeVersion += 1;
        setPendingMode('replace');
        queueSync();
      }
      renderFavorites();
    };

    const hydrateAccountFavorites = async () => {
      if (!isAuthenticated || !endpoint) return;
      const localItems = readFavorites();
      const pendingMode = readPendingMode();

      try {
        const payload = await fetchFavorites();
        const remoteItems = normalizeFavorites(payload && payload.favorites);
        let nextItems = remoteItems;

        if (pendingMode === 'replace') nextItems = localItems;
        if (pendingMode === 'merge') nextItems = mergeFavorites(localItems, remoteItems);

        storeItems(storageKey, nextItems);
        renderFavorites();

        if (pendingMode) await pushFavorites();
      } catch {
        if (pendingMode) queueSync();
      }
    };

    const toggleFavorite = (button) => {
      const items = readFavorites();
      const id = normalizeId(button.dataset.favoriteId);
      if (!id) return;

      const existing = items.findIndex((item) => item.id === id);
      if (existing >= 0) {
        items.splice(existing, 1);
        status.textContent = dialog.dataset.removedStatus;
      } else {
        items.unshift({
          id,
          handle: button.dataset.favoriteHandle || '',
          url: button.dataset.favoriteUrl || '',
          title: button.dataset.favoriteTitle || '',
          image: button.dataset.favoriteImage || '',
          price: button.dataset.favoritePrice || '',
          variantId: normalizeId(button.dataset.favoriteVariantId)
        });
        status.textContent = dialog.dataset.addedStatus;
      }
      writeFavorites(items);
    };

    document.addEventListener('click', (event) => {
      const favoriteButton = event.target.closest('[data-favorite-button]');
      if (favoriteButton) {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(favoriteButton);
        return;
      }

      if (event.target.closest('[data-favorites-open]')) {
        event.preventDefault();
        renderFavorites();
        if (!dialog.open) dialog.showModal();
        return;
      }

      if (event.target.closest('[data-favorites-close]')) {
        dialog.close();
        return;
      }

      const removeButton = event.target.closest('[data-favorite-remove]');
      if (removeButton) {
        const items = readFavorites().filter((item) => item.id !== normalizeId(removeButton.dataset.favoriteRemove));
        status.textContent = dialog.dataset.removedStatus;
        writeFavorites(items);
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    window.addEventListener('storage', (event) => {
      if (event.key === storageKey) renderFavorites();
    });

    window.addEventListener('online', () => {
      if (readPendingMode()) queueSync();
    });

    document.addEventListener('shopify:section:load', renderFavorites);

    const observer = new MutationObserver(() => {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(() => {
        syncQueued = false;
        updateButtons(readFavorites());
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    renderFavorites();
    hydrateAccountFavorites();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-localization-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.do-localization-menu__form')) return;
    const returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.do-localization-menu[open]').forEach((menu) => {
      if (menu.contains(document.activeElement)) menu.querySelector('summary')?.focus();
      menu.open = false;
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.do-localization-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["3dorder-service-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeSlider = (slider) => {
      if (slider.dataset.serviceSliderReady === 'true') return;
      slider.dataset.serviceSliderReady = 'true';
      const track = slider.querySelector('.do-service-slider__track');
      const previous = slider.querySelector('[data-service-prev]');
      const next = slider.querySelector('[data-service-next]');
      if (!track || !previous || !next) return;

      const card = track.querySelector('.do-service-slider__item');
      const events = new AbortController();
      let frame = 0;
      let measureStep = true;
      let step = 0;

      const updateControls = () => {
        frame = 0;
        // Read all geometry before changing either control.
        const left = track.scrollLeft;
        const width = track.clientWidth;
        const scrollWidth = track.scrollWidth;
        if (measureStep) {
          step = card
            ? card.getBoundingClientRect().width + (Number.parseFloat(window.getComputedStyle(track).columnGap) || 0)
            : width;
          measureStep = false;
        }
        const atStart = left <= 2;
        const atEnd = Math.ceil(left + width) >= scrollWidth - 2;
        if (previous.disabled !== atStart) previous.disabled = atStart;
        if (next.disabled !== atEnd) next.disabled = atEnd;
      };

      const scheduleUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(updateControls);
      };
      const scheduleMeasure = () => {
        measureStep = true;
        scheduleUpdate();
      };
      const scroll = (direction) => {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollBy({ left: direction * step, behavior });
      };

      previous.addEventListener('click', () => scroll(-1), { signal: events.signal });
      next.addEventListener('click', () => scroll(1), { signal: events.signal });
      track.addEventListener('scroll', scheduleUpdate, { passive: true, signal: events.signal });
      window.addEventListener('resize', scheduleMeasure, { passive: true, signal: events.signal });
      const observer = new ResizeObserver(scheduleMeasure);
      observer.observe(track);
      if (card) observer.observe(card);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(slider)) return;
        events.abort();
        observer.disconnect();
        window.cancelAnimationFrame(frame);
        delete slider.dataset.serviceSliderReady;
      }, { signal: events.signal });
      scheduleUpdate();
    };

    document.querySelectorAll('[data-service-slider]').forEach(initializeSlider);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-service-slider]').forEach(initializeSlider);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
